const getDefaultState = () => {
    return {
        nodesExpanded: {},
    }
}

const state = getDefaultState()

const getters = {
    nodesExpanded: (state: any) => state.nodesExpanded,
}

const mutations = {
    setNodesExpanded(state: any, payload: any) {
        state.nodesExpanded[payload.id] = payload.value
    },
    resetContractor() {
        // reset nodesExpanded if needed
    },
}

export default {
    state,
    getters,
    mutations,
}
